import React from "react";
import GridLayout from "../components/organisms/grid-layout/GridLayout";
import Layout from "../components/organisms/layout/layout";
import Disclaimer from "../components/molecules/disclaimer/disclaimer";
import Paginator from "../components/molecules/paginator/Paginator";
import PreviewCard, {
  PreviewCardProps,
} from "../components/molecules/PreviewCard/PreviewCard";
import Suscribe from "../components/molecules/suscribe/suscribe";
import AsideBar from "../components/organisms/aside/AsideBar";
import CategoryHeader from "../components/organisms/category-header/CategoryHeader";
import SEO from "../shared/seo";
import "./../styles/index.scss";
import { FaHeadphones } from "react-icons/fa";
import { dateToRelativeFormat } from "../utils/dateToRelativeFormat";
import { adapterSuscribe } from "../components/templates/library-components/adapters";

const templatePodcasts = (props) => {
  const episode = props.pageContext;

  return (
    <Layout hideHeaderDesktop={false} hideHeaderMobile={false}>
      <SEO
        title={"Revista Comfama | Todos los Podcasts"}
        description="Escucha todos los podcasts que Revista Comfama tiene para ti."
        lang="es"
      />
      <CategoryHeader breadcrum="Inicio/Podcasts" title="Todos los Podcasts" />
      <GridLayout columns="2fr 1fr" gap="2rem" padding="1rem 0">
        <div>
          {episode.elements?.map((element, i) => {
            let process: PreviewCardProps = {
              description:
                element.description.split(" --- ")[0].slice(0, 180) ||
                "Escucha este genial podcast de Revista Comfama.",
              imageUrl: element.images[1].url,
              leftSub: "Podcast",
              link: `/${element.slug}`,
              rightSub: dateToRelativeFormat(element.release_date),
              title: element.name,
              icon: <FaHeadphones />,
            };
            return <PreviewCard {...process} key={i} />;
          })}
        </div>
        <AsideBar />
      </GridLayout>
      <Paginator
        slug={episode.slug}
        quantity={episode.numPages}
        currentPage={episode.currentPage}
      />
      <Suscribe {...adapterSuscribe()} />
      <Disclaimer />
    </Layout>
  );
};

export default templatePodcasts;
